/*
This plugin requires perfectscrollbar and jquery.mousewheel included before the cogmenu plugin.
*/
if (!Date.now) {
    Date.now = function now() {
        return new Date().getTime();
    };
}
(function ($) {
    'use strict';

    $.fn.cogmenu = function (method) {
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exists.');
        }
    };

    var methods = {},
        mouseupBound = false,
        defaultSettings = {
            data: [],
            width: 222,
            height: null,
            hoverText: 'View Menu',
            cogStyle: 'cogBlackMedium',
            menuPosition: 'left'
        };

    methods.init = function (opt) {
        if (!mouseupBound) {
            $(document).mouseup(function(e) {
                var container = $('.cogmenu-options');

                if (!container.is(e.target) // if the target of the click isn't the container...
                    && container.has(e.target).length === 0) // ... nor a descendant of the container
                {
                    closeMenus();
                }
            });
            mouseupBound = true;
        }

        //Preserve the original defaults by passing an empty object as the target
        return this.each(function () {
            var options = $.extend({}, defaultSettings, opt),
                dropSelectHtml = '<div class="cogmenu"><div class="cogmenu-image">&nbsp;</div></div>',
                obj = $(this),
                dropDownItems = [],
                id = obj.attr('id');

            //Generate an ID if non existed on the UL
            if (!id)
                id = 'cogmenu-' + Date.now();

            obj.find('li').each(function () {
                var $this = $(this), thisData = $this.data();

                // Add all data attributes
                var dataAttributes = [];
                $.each(this.attributes, function (i, attrib) {
                    if (attrib.specified) {
                        if (attrib.name.indexOf("data-") == 0) {
                            dataAttributes.push({ attributeName: attrib.name, attributeValue: attrib.value });
                        }
                    }
                });

                // If we have an empty href tag, replace it with javascript:void(0); to keep the page from jumping to the top of the 'body' on the click
                if (thisData.href == undefined || thisData.href.length == 0 || thisData.href === '#') {
                    thisData.href = "javascript:void(0);";
                }

                dropDownItems.push({
                    html: $this.html(),
                    description: thisData.description,
                    isSeparator: $this.hasClass('separator'),
                    href: thisData.href,
                    target: thisData.target,
                    className: $this.attr('class'),
                    id: $this.attr('id'),
                    dataAttributes: dataAttributes
                });
            });
            options.data = $.merge(dropDownItems, options.data);

            var optMenuId = id + '-optmenu',
                original = obj,
                placeholder = $('<div id="' + id + '"></div>'),
                dropOptionsHtml = '<div class="cogmenu-options" id="' + optMenuId + '"></div>';

            obj.replaceWith(placeholder);
            obj = placeholder;
            
            var existingMenu = $('body').find('#' + optMenuId);
            if (existingMenu.length > 0)
                existingMenu.replaceWith(dropOptionsHtml);
            else
                $('body').append(dropOptionsHtml);
            
            obj.addClass('cogmenu-container').append(dropSelectHtml);

            var objSelect = obj.find('.cogmenu'),
                objOptions = $('body').find('#' + optMenuId);

            objSelect.addClass(options.cogStyle).attr('title', options.hoverText);
            objOptions.hide();
            objOptions.css({
                width: options.width
            });

            if (options.height != null)
                objOptions.css({
                    height: options.height
                }).perfectScrollbar({ includePadding: true });

            $.each(options.data, function (index, item) {
                if (item.isSeparator)
                    objOptions.append('<div class="cogmenu-separator">&nbsp;</div>');
                else {
                    var cogItemDiv = '<div class="cogmenu-item ' +
                    (item.className ? item.className + '"' : '"') +
                    (item.id ? 'id="' + item.id + '"' : '') +
                    (item.description ? ' title="' + item.description + '"' : '') +
                    (item.href ? ' data-href="' + item.href + '"' : '') +
                    (item.target ? ' data-target="' + item.target + '"' : '');
                    // Data Attributes
                    $.each(item.dataAttributes, function (index, attributeItem) {
                        cogItemDiv = cogItemDiv + ' ' + attributeItem.attributeName + '="' + attributeItem.attributeValue + '"';
                    });
                    cogItemDiv = cogItemDiv + '>' +
                        item.html +
                        '</div>';

                    objOptions.append(cogItemDiv);
                }
            });

            var pluginData = {
                settings: options,
                original: original
            }

            obj.data('cogmenuData', pluginData);

            obj.find('.cogmenu').on('click', function () {
                open(obj, id, optMenuId);
            });

            $('body').find('.cogmenu-item').on('click', function () {
                navigate(this);
            });

            $('body').find('#' + optMenuId).on('click', function () {
                closeMenus();
            });

            $('.cogmenu-image').addClass('closed');
        });
    }
    methods.open = function () {
        return this.each(function () {
            open($(this));
        });
    }
    methods.clear = function () {
        return this.each(function () {
            var obj = $(this);
            obj.find('.cogmenu').unbind('click');
            obj.find('.cogmenu-item').unbind('click');
            obj.find('.cogmenu-options').unbind('click');
        });
    }
    function open(obj) {
        var $this = obj.find('.cogMenu'),
            id = obj.attr('id'),
            dropOptions = $('body').find('#' + id + '-optmenu'), //obj.find('.cogmenu-options'),
            pointer = obj.find('.cogmenu-image'),
            wasOpen = dropOptions.is(':visible'),
			pluginData = obj.data('cogmenuData');

        closeMenus();

        if (wasOpen) {
            dropOptions.slideUp('fast');
            pointer.removeClass('open').removeClass('closed').addClass('closed');
        }
        else {
            var pos = obj.offset(),
                objWidth = obj.outerWidth(),
                objHeight = obj.outerHeight(),
                menuWidth = dropOptions.outerWidth(),
                menuHeight = dropOptions.outerHeight();

            dropOptions.css('top', (pos.top + objHeight + 5) + 'px');
            if (pluginData.settings.menuPosition == 'right') {
                dropOptions.css('left', (pos.left - menuWidth + objWidth) + 8 + 'px');
            } else {
                dropOptions.css('left', (pos.left) - 8 + 'px');
            }

            dropOptions.slideDown('fast');
            if (pluginData.settings.height != null)
                setTimeout(function () { updateScroll(dropOptions); }, 100);
            pointer.removeClass('open').removeClass('closed').addClass('open');
        }
    }

    function closeMenus() {
        $('.cogmenu-options').slideUp(50);
        $('.cogmenu-image').removeClass('open').removeClass('closed').addClass('closed');
    }

    $(window).resize(function () {
        closeMenus();
    });

    function navigate(obj) {
        var data = $(obj).data();
        if (data.href) {

            if (data.href === 'javascript.void(0);')
                return;

            if (data.target)
                window.open(data.href, data.target);
            else
                window.location.href = data.href;
        }
    }

    function updateScroll(obj) {
        obj.perfectScrollbar('update');
    }
}(jQuery));

/*
Sample Usage
<html>
<head>
	<link rel="stylesheet" href="Css/perfect-scrollbar.css">
	<link rel="stylesheet" href="Css/cogmenu.css">
	<script src="http://ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js"></script>
	<script src="Script/jquery.mousewheel.js"></script>
	<script src="Script/perfect-scrollbar.js"></script>
	<script src="Script/cogmenu.js"></script>
	<script>
		$(function () {
			$('#menu').cogmenu({height: 300});
			$('#menu2').cogmenu();
		});
	</script>
</head>
<body>
	<h1>Cog Menu Sample</h1>
	<div style="display:inline-block;padding-right:10px;">Sample stuff</div>
	<ul id="menu">
		<li data-href="http://www.google.com" data-description="Go to Google!!">Google</li>
		<li data-href="http://www.facebook.com">Facebook</li>
		<li class="separator"></li>
		<li data-href="http://www.microsoft.com">Microsoft</li>
		<li data-href="http://www.google.com" data-description="Go to Google!!">Google</li>
		<li data-href="http://www.facebook.com">Facebook</li>
		<li class="separator"></li>
		<li data-href="http://www.microsoft.com">Microsoft</li>
		<li data-href="http://www.google.com" data-description="Go to Google!!">Google</li>
		<li data-href="http://www.facebook.com">Facebook</li>
		<li class="separator"></li>
		<li data-href="http://www.microsoft.com">Microsoft</li>
		<li data-href="http://www.google.com" data-description="Go to Google!!">Google</li>
		<li data-href="http://www.facebook.com">Facebook</li>
		<li class="separator"></li>
		<li data-href="http://www.microsoft.com">Microsoft</li>
	</ul>
	<br /><br /><br /><br />
	<div style="display:inline-block;padding-right:10px;">Menu 2</div>
	<ul id="menu2">
		<li data-href="http://www.google.com" data-description="Go to Google!!">Google</li>
		<li data-href="http://www.facebook.com" data-description="Go to Facebook" data-target="_blank">Facebook</li>
		<li class="separator"></li>
		<li data-href="http://www.microsoft.com">Microsoft</li>
	</ul>
</body>
</html>
*/